import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useEffect } from 'react';

import { getZorGeneralSetting } from '@/actions/zor-general-setting/getZorGeneralSetting';
import { setBrandColorVariables } from '@/lib/brand-colors';
import { ApiResponse } from '@/types/response.type';
import { ZorGeneralSetting } from '@/types/zor.general-setting.type';

export interface UseGetZorGeneralSettingReturn {
  result: ApiResponse<ZorGeneralSetting> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetZorGeneralSetting = (): UseGetZorGeneralSettingReturn => {
  const query: UseQueryResult<
    ApiResponse<ZorGeneralSetting> | undefined,
    Error
  > = useQuery({
    queryKey: ['zor-general-setting'],
    queryFn: getZorGeneralSetting,
  });

  useEffect(() => {
    if (query.data?.data?.brand_colors) {
      setBrandColorVariables(query.data?.data?.brand_colors);
    }
  }, [query.data?.data?.brand_colors]);

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
